import { mapGetters } from 'vuex'
import { checkEmail, checkPhone } from '@/utils/validate-rules'

export default {
  computed: {
    ...mapGetters(['currentAccount']),
  },

  created() {
    this.initAccountFromStore()
  },
  methods: {
    checkAccount(type, value) {
      let result = false
      if (type === 'phone') {
        result = checkPhone(value)
      } else if (type === 'email') {
        result = checkEmail(value)
      }
      return result
    },
    initAccountFromStore() {
      const result = this.checkAccount(this.type, this.currentAccount)
      if (result) {
        this.form[this.type] = this.currentAccount
      }
    },
    setAccount(value) {
      const result = this.checkAccount(this.type, value)
      if (result) {
        this.$store.commit('setCurrentAccount', value)
      }
    },
    nameFilter(key) {
      if (this.form[key]) {
        // 去掉首尾空格 去掉中间多余空格
        this.form[key] = this.form[key]
          .replace(/^\s+|\s+$/g, '')
          .replace(/\s+/g, ' ')
      }
    },
  },
}
